module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921022649_T.7d9774e2.jpg";